export const getCID = () => {
    const pattern = /(\d+\.\d+)$/;
    const gaCookie = getCookie('_ga');
    const match = pattern.exec(gaCookie);
    return gaCookie && match ? match[0] : '';
};
export const getEnvironment = () => {
    const envMap = {
        dev: 'dev',
        preview: 'preprod',
        live: 'prod',
    };
    const env = (process.env.ENVIRONMENT ?? 'dev');
    return envMap[env] ?? 'dev';
};
export const isProductionEnv = () => {
    return getEnvironment() === 'prod';
};
export const getCookie = (name) => document.cookie
    .split('; ')
    .find((row) => row.startsWith(`${name}=`))
    ?.split('=')[1] ?? '';
export const getBrokerId = () => {
    const token = getCookie('oauth.access.token');
    const { sub } = JSON.parse(atob(token.split('.')[1] ?? ''));
    return sub;
};
